/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './getTrendsSkeleton.defs.js'
export * as $defs from './getTrendsSkeleton.defs.js'
